import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';

interface PopupProps {
    children: any;
    open: boolean;
    close: any;
    style?: object;
}

const Popup = (props: PopupProps) => {

    const { children, open, close, style } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [show, setShow] = useState(false);

    useEffect(() => {
        document.onkeydown = function (evt) {
            if (open) {
                let event = evt || window.event;
                var isEscape = false;
                if ("key" in event) {
                    isEscape = (event['key'] === "Escape" || event['key'] === "Esc");
                } else {
                    isEscape = (event['keyCode'] === 27);
                }
                if (isEscape) {
                    close();
                }
            }
        };
    }, [open])

    useEffect(() => {
        if (open) {
            setIsOpen(true);
            setShow(true);
        } else {
            setShow(false);
            setTimeout(() => {
                setIsOpen(false);
            }, 200);
        }
    }, [open]);

    if (!isOpen) {
        return null;
    }

    return <><div onClick={close} className={`${styles.overlay} ${show ? styles.show : undefined}`}></div>
        <div className={`${styles.wrapper} ${show ? styles.show : undefined}`}>
            <div className={`${styles.container} ${show ? styles.show : undefined}`} style={style}>
                <div className={styles.button} onClick={close}></div>
                {children}
            </div>
        </div>
    </>

}

export default Popup;